import { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { ScrollSection } from "../components/ScrollSection";

function AboutUs() {
	const { tab } = useParams();
	const navigate = useNavigate();
	const [activeTab, setActiveTab] = useState(tab || "overview");

	useEffect(() => {
		if (tab) {
			setActiveTab(tab);
		} else {
			setActiveTab("overview");
		}
	}, [tab]);

	const handleTabChange = (tabId) => {
		setActiveTab(tabId);
		navigate(`/about-us/${tabId}`);
		window.scrollTo(0, 0);
	};

	const renderTabContent = () => {
		switch (activeTab) {
			case "overview":
				return (
					<>
						{/* TGH Overview Section - First */}
						<div className="row mb-5">
							<div className="col-12">
								<div className="position-relative mb-4">
									<h2
										className="mb-0 about-us-bg-title"
										style={{
											fontWeight: "bold",
											color: "rgba(var(--tgh-blue-rgb), 0.1)",
											position: "absolute",
											top: "-20px",
											left: "0",
											zIndex: 0,
										}}>
										Overview
									</h2>
									<h2
										className="position-relative about-us-main-title"
										style={{
											fontWeight: "bold",
											color: "#333",
											borderBottom: "3px solid #dc3545",
											paddingBottom: "10px",
											display: "inline-block",
											zIndex: 1,
										}}>
										TGH Overview
									</h2>
								</div>
								<div className="row align-items-center">
									<div className="col-12 col-lg-7">
										<h3
											className="mb-3"
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.6rem",
												fontWeight: "bold",
											}}>
											Introduction
										</h3>
										<p
											className="mb-3 about-us-text"
											style={{ lineHeight: "1.8", textAlign: "justify" }}>
											Tema General Hospital (TGH) is a major public health
											facility located in the Tema Metropolis of the Greater
											Accra Region of Ghana. It serves as a key secondary-level
											referral hospital, providing comprehensive medical services
											to residents of Tema and surrounding communities. The
											hospital operates under the Ghana Health Service and plays a
											vital role in delivering accessible, affordable, and quality
											healthcare to the population.
										</p>
										<p
											className="mb-3 about-us-text"
											style={{ lineHeight: "1.8" }}>
											At <strong>TGH</strong>, we are dedicated to providing
											exceptional healthcare services to the community with
											compassion, expertise, and integrity. Established as a
											leading medical facility in the region, we offer a
											comprehensive range of services including emergency care,
											outpatient services, inpatient care, and specialized
											treatments.
										</p>
										<p
											className="mb-3 about-us-text"
											style={{ lineHeight: "1.8" }}>
											Our team of highly skilled healthcare professionals,
											including doctors, nurses, and support staff, is committed
											to delivering patient-centered care with a focus on the
											highest standards of medical excellence. We utilize
											advanced medical technologies and evidence-based practices
											to ensure the best outcomes for our patients.
										</p>
										<p
											className="mb-0 about-us-text"
											style={{ lineHeight: "1.8" }}>
											We believe in treating every patient with dignity and
											respect, and we strive to create a welcoming environment
											where everyone feels cared for and valued. At{" "}
											<strong>TGH</strong>, we are not just about treating
											illness; we are about fostering wellness and promoting
											health in our community.
										</p>
									</div>
									<div className="col-12 col-lg-5 mt-4 mt-lg-0">
										<Swiper
											modules={[Autoplay, Pagination]}
											slidesPerView={1}
											loop
											autoplay={{ delay: 3000, disableOnInteraction: false }}
											pagination={{ clickable: true }}
											className="about-us-overview-slider">
											<SwiperSlide className="about-us-overview-slide">
												<img
													src="/img/carousel/admin2.jpg"
													alt="Tema General Hospital - Administration Block"
													className="img-fluid rounded shadow-sm"
													style={{
														width: "100%",
														height: "auto",
														objectFit: "cover",
													}}
												/>
											</SwiperSlide>
											<SwiperSlide className="about-us-overview-slide">
												<img
													src="/img/carousel/Bloodbank.jpg"
													alt="Tema General Hospital - Blood bank"
													className="img-fluid rounded shadow-sm"
													style={{
														width: "100%",
														height: "auto",
														objectFit: "cover",
													}}
												/>
											</SwiperSlide>
											<SwiperSlide className="about-us-overview-slide">
												<img
													src="/img/carousel/DART.jpg"
													alt="Tema General Hospital - DART Unit"
													className="img-fluid rounded shadow-sm"
													style={{
														width: "100%",
														height: "auto",
														objectFit: "cover",
													}}
												/>
											</SwiperSlide>
											<SwiperSlide className="about-us-overview-slide">
												<img
													src="/img/carousel/physio.jpg"
													alt="Tema General Hospital - Physiotherapy Department"
													className="img-fluid rounded shadow-sm"
													style={{
														width: "100%",
														height: "auto",
														objectFit: "cover",
													}}
												/>
											</SwiperSlide>
										</Swiper>
									</div>
								</div>
							</div>
						</div>

						{/* Vision, Mission, Core Values Cards - Last */}
						<div className="row g-4 mb-5">
							<div className="col-12 col-md-6 col-lg-4">
								<div
									className="card border-0 shadow-sm h-100"
									style={{ borderRadius: "8px" }}>
									<div className="card-body text-center p-4">
										<div
											className="mb-3 about-us-icon"
											style={{ color: "#dc3545" }}>
											<i className="bi bi-eye-fill"></i>
										</div>
										<h3
											className="mb-3 about-us-card-title"
											style={{ color: 'var(--tgh-blue)', fontWeight: "bold" }}>
											Vision
										</h3>
										<p
											className="text-muted mb-0 about-us-card-text"
											style={{ lineHeight: "1.6" }}>
											All communities having access to timely, quality and
											comprehensive health care
										</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-6 col-lg-4">
								<div
									className="card border-0 shadow-sm h-100"
									style={{ borderRadius: "8px" }}>
									<div className="card-body text-center p-4">
										<div
											className="mb-3 about-us-icon"
											style={{ color: "#dc3545" }}>
											<i className="bi bi-lightbulb-fill"></i>
										</div>
										<h3
											className="mb-3 about-us-card-title"
											style={{ color: 'var(--tgh-blue)', fontWeight: "bold" }}>
											Mission
										</h3>
										<p
											className="text-muted mb-0 about-us-card-text"
											style={{ lineHeight: "1.6" }}>
											To provide and prudently manage comprehensive and
											accessible health service with special emphasis on primary
											health care at regional, district and sub-district levels
											in accordance with approved national policies
										</p>
									</div>
								</div>
							</div>
							<div className="col-12 col-md-6 col-lg-4">
								<div
									className="card border-0 shadow-sm h-100"
									style={{ borderRadius: "8px" }}>
									<div className="card-body text-center p-4">
										<div
											className="mb-3 about-us-icon"
											style={{ color: "#dc3545" }}>
											<i className="bi bi-building"></i>
										</div>
										<h3
											className="mb-3 about-us-card-title"
											style={{ color: 'var(--tgh-blue)', fontWeight: "bold" }}>
											Core Values
										</h3>
										<ul className="list-unstyled text-start text-muted about-us-values-list">
											<li className="mb-2">
												<span style={{ color: "#dc3545", marginRight: "8px" }}>
													●
												</span>
												People-Centered
											</li>
											<li className="mb-2">
												<span style={{ color: "#dc3545", marginRight: "8px" }}>
													●
												</span>
												Professionalism
											</li>
											<li className="mb-2">
												<span style={{ color: "#dc3545", marginRight: "8px" }}>
													●
												</span>
												Team Work
											</li>
											<li className="mb-2">
												<span style={{ color: "#dc3545", marginRight: "8px" }}>
													●
												</span>
												Innovation / Excellence
											</li>
											<li className="mb-2">
												<span style={{ color: "#dc3545", marginRight: "8px" }}>
													●
												</span>
												Discipline
											</li>
											<li className="mb-2">
												<span style={{ color: "#dc3545", marginRight: "8px" }}>
													●
												</span>
												Integrity
											</li>
										</ul>
									</div>
								</div>
							</div>
						</div>

						{/* Strategic Objectives Section */}
						<div className="row">
							<div className="col-12">
								<div
									className="about-us-objectives-section py-5 px-4"
									style={{ backgroundColor: "#2d5016", borderRadius: "8px" }}>
									<div className="position-relative mb-4">
										<h2
											className="position-relative text-white mb-0 about-us-objectives-title"
											style={{
												fontWeight: "bold",
												borderBottom: "3px solid #dc3545",
												paddingBottom: "10px",
												display: "inline-block",
												zIndex: 1,
											}}>
											Strategic Objectives
										</h2>
										<span
											className="about-us-objectives-bg"
											style={{
												fontWeight: "bold",
												color: "rgba(255, 255, 255, 0.1)",
												position: "absolute",
												top: "-20px",
												left: "0",
												zIndex: 0,
											}}>
											Objectives
										</span>
									</div>
									<div className="row mt-4">
										<div className="col-12 col-lg-6">
											<ul className="list-unstyled">
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													Ensure sustainable, affordable, equitable and easily
													accessible Health Care services.
												</li>
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													Enhance efficiency in governance and management of the
													health system.
												</li>
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													Improve quality of health service delivery including
													mental health.
												</li>
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													Intensify prevention and control of Communicable
													diseases and ensure reduction of new HIV and other STI
													especially among the vulnerable group.
												</li>
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													Reduce Morbidity and mortality; intensify prevention
													and control of Non-communicable diseases.
												</li>
											</ul>
										</div>
										<div className="col-12 col-lg-6">
											<ul className="list-unstyled">
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													To Provide Quality Clinical, Public Health and
													Research Services
												</li>
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													To Create Efficiency in Governance Practices and
													Management Systems
												</li>
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													To Ensure the Financial Sustainability of the Hospital
												</li>
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													To Develop and Utilize Human Resource
												</li>
												<li
													className="mb-3 text-white about-us-objectives-item"
													style={{ lineHeight: "1.8" }}>
													<span
														className="me-3"
														style={{ color: "#fff", fontSize: "0.8rem" }}>
														○
													</span>
													To Optimize Information and Communications and
													Technology
												</li>
											</ul>
										</div>
									</div>
								</div>
							</div>
						</div>
					</>
				);
			case "history":
				return (
					<div style={{ maxWidth: "1200px", margin: "0 auto" }}>
						{/* Brief History Section */}
						<ScrollSection>
							<div
								className="position-relative mb-5"
								style={{ marginTop: "20px" }}>
								<h2
									className="mb-0"
									style={{
										fontWeight: "bold",
										color: "rgba(var(--tgh-blue-rgb), 0.1)",
										position: "absolute",
										top: "-20px",
										left: "0",
										zIndex: 0,
										fontSize: "4rem",
										fontFamily: "Georgia, serif",
									}}>
									History
								</h2>
								<h2
									className="position-relative"
									style={{
										fontWeight: "bold",
										color: 'var(--tgh-blue-light)',
										borderBottom: "3px solid #dc3545",
										paddingBottom: "10px",
										display: "inline-block",
										zIndex: 1,
										fontFamily: "Georgia, serif",
										fontSize: "2.5rem",
									}}>
									Brief History
								</h2>
							</div>

							<div className="row mb-5">
								<div className="col-12">
									<div style={{ position: "relative" }}>
										<div
											className="history-image-wrap"
											style={{
												float: "right",
												marginLeft: "2rem",
												marginBottom: "1rem",
												maxWidth: "400px",
												width: "100%",
											}}>
											<div
												style={{
													position: "relative",
													borderRadius: "8px",
													overflow: "hidden",
													boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
												}}>
												<img
													src="/img/Gallery/history.jpg"
													alt="Tema General Hospital"
													style={{
														width: "100%",
														height: "auto",
														display: "block",
														borderRadius: "8px",
													}}
													onError={(e) => {
														e.target.src = "/img/Gallery/tema-genold.jpg";
													}}
												/>
												<div
													style={{
														position: "absolute",
														top: 0,
														left: 0,
														right: 0,
														bottom: 0,
														background:
															"linear-gradient(to bottom, rgba(0, 102, 204, 0.1), rgba(0, 102, 204, 0.3))",
														pointerEvents: "none",
													}}></div>
											</div>
										</div>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.6rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Historical Background
										</h3>
										<p
											style={{
												fontSize: "1.1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1.5rem",
												textAlign: "justify",
											}}>
											Tema General Hospital, established in{" "}
											<strong>1954</strong>, was originally built to serve
											workers involved in the construction of the Tema Harbour.
											After fulfilling this initial purpose, the hospital was
											handed over to the Government of Ghana in{" "}
											<strong>1962</strong> for public use, marking the start of
											its broader role in healthcare delivery within the Tema
											Metropolitan Area. Strategically located with access to a
											robust road network and situated in a key commercial hub,
											the hospital has grown into one of the busiest healthcare
											facilities in the country. Over the years, Tema General
											Hospital has become a major referral point for other
											clinics and hospitals within the metropolis, particularly
											catering to road traffic and industrial accident victims,
											including those from the nearby motorway.
										</p>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.6rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Location and Catchment Area
										</h3>
										<p
											style={{
												fontSize: "1.1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1.5rem",
												textAlign: "justify",
											}}>
											The hospital serves an extensive catchment area that
											covers the entire Tema Metropolis and its surrounding
											towns and villages, including{" "}
											<strong>Sakumono, Lashibi, Nungua</strong>, and even the{" "}
											<strong>Dangme West and Dangme East districts</strong>.
											This wide reach ensures that Tema General Hospital plays a
											vital role in addressing the healthcare needs of the
											region's diverse and populous communities.
										</p>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.6rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Bed Capacity and Infrastructure
										</h3>
										<p
											style={{
												fontSize: "1.1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1.5rem",
												textAlign: "justify",
											}}>
											Tema General Hospital has an estimated bed capacity of three
											hundred and eighty-three (383) beds, distributed across
											seventeen (17) wards including the HDU and VIP wards,
											providing inpatient and emergency services.
										</p>
										<p
											style={{
												fontSize: "1.1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1.5rem",
												textAlign: "justify",
											}}>
											With the introduction of the{" "}
											<strong>National Health Insurance Scheme (NHIS)</strong>,
											hospital attendance surged dramatically, with outpatient
											visits increasing from{" "}
											<strong>180,914 in 2007 to 207,329 in 2008</strong>.
											However, the hospital's ability to handle the increased
											demand has been strained by several challenges. These
											include insufficient staffing, inadequate accommodation
											for employees, poor infrastructure with structural
											defects, and a lack of security personnel. Additionally,
											the hospital's mortuary was shut down due to its
											deteriorated condition, and the absence of a pathologist
											has complicated autopsy procedures. Financially, NHIS
											reimbursement delays and the use of district-level tariffs
											for claims further strain the hospital's resources.
										</p>
										<p
											style={{
												fontSize: "1.1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1.5rem",
												textAlign: "justify",
											}}>
											Core clinical services at Tema General Hospital include
											general clinical services, internal medicine, surgery,
											anaesthesia services, intensive care services,
											paediatrics, obstetrics and gynaecology, accident and
											emergency services, and theatre services. The hospital
											also provides specialized clinics such as Eye Clinic,
											Dental Clinic, ENT (Ear, Nose and Throat) Clinic,
											Diabetic Clinic, Sickle Cell Clinic, Dermatology Clinic,
											Chest Clinic, and Hypertension Clinic. These services
											ensure comprehensive care for both acute and chronic
											medical conditions.
										</p>
										<p
											style={{
												fontSize: "1.1rem",
												lineHeight: "1.8",
												color: "#333",
												textAlign: "justify",
											}}>
											Diagnostic and support services at Tema General Hospital
											include Medical Laboratory and Blood Bank services,
											Radiology services, Pharmacy services, Physiotherapy
											services, and NHIS services. The hospital is further
											supported by Baby and Mother Friendly Initiative
											facilities, disability-friendly facilities, and
											customer-care-focused systems, while promotion of maternal
											health programmes remains an integral part of its
											functions. The hospital also supports major public health
											and specialized programmes including Maternal and Child
											Health services, Immunization services, HIV/AIDS (ART and
											PMTCT) services, Tuberculosis (DOTS) services,
											Non-Communicable Disease clinics, and Family Planning
											services, all of which contribute significantly to
											improving community health outcomes.
										</p>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.6rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Role in Healthcare Delivery
										</h3>
										<p
											style={{
												fontSize: "1.1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1.5rem",
												textAlign: "justify",
											}}>
											Tema General Hospital plays a significant role in
											healthcare delivery within the Greater Accra Region. As a
											secondary-level referral facility, it manages complex cases
											referred from both public and private health facilities.
											The hospital contributes to emergency and trauma care,
											maternal and neonatal care, specialist outpatient and
											inpatient services, training of healthcare professionals,
											and public health surveillance. It handles a large volume
											of deliveries annually and supports maternal and neonatal
											health services across the region.
										</p>
										<div style={{ clear: "both" }}></div>
									</div>
								</div>
							</div>
						</ScrollSection>

						{/* TGH Background Section */}
						<ScrollSection>
							<div
								className="position-relative mb-5"
								style={{ marginTop: "60px" }}>
								<h2
									className="mb-0"
									style={{
										fontWeight: "bold",
										color: "rgba(var(--tgh-blue-rgb), 0.1)",
										position: "absolute",
										top: "-20px",
										left: "0",
										zIndex: 0,
										fontSize: "4rem",
										fontFamily: "Georgia, serif",
									}}>
									Background
								</h2>
								<h2
									className="position-relative"
									style={{
										fontWeight: "bold",
										color: 'var(--tgh-blue-light)',
										borderBottom: "3px solid #dc3545",
										paddingBottom: "10px",
										display: "inline-block",
										zIndex: 1,
										fontFamily: "Georgia, serif",
										fontSize: "2.5rem",
									}}>
									TGH Background
								</h2>
							</div>

							<div className="row mb-5">
								<div className="col-12">
									<p
										style={{
											fontSize: "1.1rem",
											lineHeight: "1.8",
											color: "#333",
											marginBottom: "2rem",
											textAlign: "justify",
										}}>
										Tema General Hospital (TGH) stands as a cornerstone of
										healthcare excellence in the Greater Accra Region, dedicated
										to delivering comprehensive and compassionate medical
										services to the community. Established to meet the growing
										health needs of the bustling industrial city of Tema and its
										environs, the hospital has evolved into a reputable
										institution known for its patient-centered care, skilled
										workforce, and commitment to quality healthcare delivery.
									</p>
								</div>
							</div>

							<div className="row mb-5">
								<div className="col-12">
									<div
										style={{
											backgroundColor: "#f8f9fa",
											padding: "2rem",
											borderRadius: "8px",
											borderLeft: '4px solid var(--tgh-blue-light)',
										}}>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.5rem",
												fontWeight: "bold",
												marginBottom: "1rem",
											}}>
											Comprehensive Medical Services
										</h3>
										<p
											style={{
												fontSize: "1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1rem",
												textAlign: "justify",
											}}>
											TGH provides a wide range of medical services designed to
											cater to diverse healthcare needs. From emergency and
											critical care to specialized clinics, maternity, surgery,
											pediatric, and outpatient services, the hospital operates
											with a focus on accessibility and efficiency. Modern
											diagnostic equipment, advanced treatment methods, and
											evidence-based practices ensure that every patient
											receives care that meets the highest medical standards.
										</p>
									</div>
								</div>
							</div>

							<div className="row mb-5">
								<div className="col-12 col-lg-6 mb-4 mb-lg-0">
									<div
										style={{
											backgroundColor: "#e8f4f8",
											padding: "2rem",
											borderRadius: "8px",
											height: "100%",
											border: "1px solid var(--tgh-blue-light)",
										}}>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.5rem",
												fontWeight: "bold",
												marginBottom: "1rem",
											}}>
											Dedicated Healthcare Team
										</h3>
										<p
											style={{
												fontSize: "1rem",
												lineHeight: "1.8",
												color: "#333",
												textAlign: "justify",
											}}>
											Central to the hospital's success is its team of dedicated
											healthcare professionals — doctors, nurses, allied health
											workers, and support staff — who work collaboratively to
											uphold the hospital's values of professionalism,
											integrity, and teamwork. Continuous training, mentorship,
											and capacity building are priorities at TGH, ensuring that
											staff remain abreast of the latest medical advancements
											and best practices.
										</p>
									</div>
								</div>
								<div className="col-12 col-lg-6">
									<div
										style={{
											backgroundColor: "#e8f4f8",
											padding: "2rem",
											borderRadius: "8px",
											height: "100%",
											border: "1px solid var(--tgh-blue-light)",
										}}>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.5rem",
												fontWeight: "bold",
												marginBottom: "1rem",
											}}>
											Teaching & Learning Environment
										</h3>
										<p
											style={{
												fontSize: "1rem",
												lineHeight: "1.8",
												color: "#333",
												textAlign: "justify",
											}}>
											Beyond clinical services, Tema General Hospital serves as
											an essential teaching and learning environment for medical
											and nursing students from various institutions. By
											providing practical experience and mentorship, the
											hospital contributes significantly to developing the next
											generation of healthcare professionals and strengthening
											the country's human resource capacity for health.
										</p>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-12">
									<p
										style={{
											fontSize: "1.1rem",
											lineHeight: "1.8",
											color: "#333",
											textAlign: "justify",
										}}>
										TGH remains committed to innovation, community engagement,
										and continuous improvement. Working closely with the Greater
										Accra Regional Health Directorate and other stakeholders,
										the hospital strives to expand access to quality healthcare,
										promote health education, and implement initiatives that
										enhance patient care and community well-being. Through
										dedication and a spirit of service, Tema General Hospital
										continues to play a vital role in improving lives and
										advancing public health in Ghana.
									</p>
								</div>
							</div>
						</ScrollSection>
					</div>
				);
			case "governance":
				return (
					<div style={{ maxWidth: "1200px", margin: "0 auto" }}>
						{/* Organizational Structure Introduction */}
						<ScrollSection>
							<div
								className="position-relative mb-5"
								style={{ marginTop: "20px" }}>
								<h2
									className="mb-0 governance-bg-title"
									style={{
										fontWeight: "bold",
										color: "rgba(var(--tgh-blue-rgb), 0.1)",
										position: "absolute",
										top: "-20px",
										left: "0",
										zIndex: 0,
										fontSize: "4rem",
										fontFamily: "Georgia, serif",
									}}>
									Structure
								</h2>
								<h2
									className="position-relative governance-main-title"
									style={{
										fontWeight: "bold",
										color: 'var(--tgh-blue-light)',
										borderBottom: "3px solid #dc3545",
										paddingBottom: "10px",
										display: "inline-block",
										zIndex: 1,
										fontFamily: "Georgia, serif",
										fontSize: "2.5rem",
									}}>
									Organizational Structure
								</h2>
							</div>

							<div className="row mb-5">
								<div className="col-12">
									<p
										className="governance-text"
										style={{
											fontSize: "1.1rem",
											lineHeight: "1.8",
											color: "#333",
											marginBottom: "1.5rem",
											textAlign: "justify",
										}}>
										Tema General Hospital (TGH) exists to deliver quality
										healthcare services and promote the well-being of the
										communities it serves. To achieve this mission, the
										hospital's goals are translated into specific tasks, which
										form the basis for jobs and roles across the facility. These
										jobs are grouped into departments, each focusing on
										specialized functions within healthcare delivery. Within
										these departments, further distinctions exist in the
										responsibilities and duties performed by individuals and
										teams. The departments are linked together to form the
										broader organizational structure of the hospital.
									</p>
									<p
										className="governance-text"
										style={{
											fontSize: "1.1rem",
											lineHeight: "1.8",
											color: "#333",
											marginBottom: "1.5rem",
											textAlign: "justify",
										}}>
										The organizational structure of TGH refers to the formal
										arrangement of roles, responsibilities, and lines of
										authority within the hospital. At its core, the structure
										defines how work is divided among the hospital's staff and
										how their activities are coordinated to ensure that services
										align with the hospital's goals and standards of care. By
										clearly defining roles and reporting relationships, the
										hospital can ensure accountability, efficiency, and
										collaboration across all units.
									</p>
									<p
										className="governance-text"
										style={{
											fontSize: "1.1rem",
											lineHeight: "1.8",
											color: "#333",
											marginBottom: "1.5rem",
											textAlign: "justify",
										}}>
										The structure of Tema General Hospital directly influences
										how the hospital operates in two key ways. First, it
										provides the foundation for standard operating procedures
										and workflows, ensuring that services are delivered safely
										and consistently. Second, it determines how decisions are
										made within the hospital, outlining which individuals or
										groups participate in various decision-making processes and
										how their input shapes the hospital's actions and policies.
									</p>
									<p
										className="governance-text"
										style={{
											fontSize: "1.1rem",
											lineHeight: "1.8",
											color: "#333",
											marginBottom: "1.5rem",
											textAlign: "justify",
										}}>
										The organizational structure is typically represented in an
										organization chart. This chart visually depicts how roles,
										responsibilities, and departments are arranged at a given
										point in time. It shows the hierarchy of authority, the
										chain of command, and the formal relationships that connect
										different parts of the hospital. The organization chart
										helps staff, stakeholders, and partners understand how work
										is structured and how responsibilities are distributed.
									</p>
									<p
										className="governance-text"
										style={{
											fontSize: "1.1rem",
											lineHeight: "1.8",
											color: "#333",
											textAlign: "justify",
										}}>
										At Tema General Hospital, the organizational structure
										ensures a clear chain of command and accountability across
										all operational areas. The Medical Superintendent serves as
										the Chief Executive Officer of the hospital, with overall
										responsibility for the management and performance of all
										clinical and non-clinical departments. Through this
										well-defined structure, TGH fosters effective communication,
										smooth coordination, and a shared commitment to delivering
										high-quality healthcare services to the people of Tema and
										beyond.
									</p>
								</div>
							</div>
						</ScrollSection>

						{/* Governance Hierarchy */}
						<ScrollSection>
							<div
								className="position-relative mb-5 governance-section-spacing"
								style={{ marginTop: "60px" }}>
								<h2
									className="mb-0 governance-bg-title"
									style={{
										fontWeight: "bold",
										color: "rgba(var(--tgh-blue-rgb), 0.1)",
										position: "absolute",
										top: "-20px",
										left: "0",
										zIndex: 0,
										fontSize: "4rem",
										fontFamily: "Georgia, serif",
									}}>
									Governance
								</h2>
								<h2
									className="position-relative governance-main-title"
									style={{
										fontWeight: "bold",
										color: 'var(--tgh-blue-light)',
										borderBottom: "3px solid #dc3545",
										paddingBottom: "10px",
										display: "inline-block",
										zIndex: 1,
										fontFamily: "Georgia, serif",
										fontSize: "2.5rem",
									}}>
									Governance Structure
								</h2>
							</div>

							<div className="row mb-5">
								<div className="col-12">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#e8f4f8",
											padding: "2rem",
											borderRadius: "8px",
											border: "1px solid var(--tgh-blue-light)",
											marginBottom: "2rem",
										}}>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.5rem",
												fontWeight: "bold",
												marginBottom: "1rem",
											}}>
											Medical Director
										</h3>
										<p
											style={{
												fontSize: "1rem",
												lineHeight: "1.8",
												color: "#333",
												textAlign: "justify",
											}}>
											At the top of the chart is the Medical Director, who
											serves as the Chief Executive Officer. The Medical
											Director is responsible for overseeing all operations and
											activities within the hospital, ensuring that the hospital
											runs efficiently and effectively to provide high-quality
											healthcare services.
										</p>
									</div>
								</div>
							</div>

							<div className="row mb-4">
								<div className="col-12 col-lg-6 mb-4 mb-lg-0">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#f8f9fa",
											padding: "1.5rem",
											borderRadius: "8px",
											height: "100%",
											borderLeft: '4px solid var(--tgh-blue-light)',
										}}>
										<h4
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.2rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Internal Audit
										</h4>
										<p
											style={{
												fontSize: "0.95rem",
												lineHeight: "1.7",
												color: "#333",
												textAlign: "justify",
											}}>
											Reporting directly to the Medical Director is the Internal
											Audit function. This unit is tasked with ensuring
											compliance with internal controls, policies, and
											regulations. The Internal Audit team conducts audits to
											safeguard the hospital's integrity and accountability,
											ensuring that all operations adhere to established
											standards and procedures.
										</p>
									</div>
								</div>
								<div className="col-12 col-lg-6">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#f8f9fa",
											padding: "1.5rem",
											borderRadius: "8px",
											height: "100%",
											borderLeft: '4px solid var(--tgh-blue-light)',
										}}>
										<h4
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.2rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Human Resource Management
										</h4>
										<p
											style={{
												fontSize: "0.95rem",
												lineHeight: "1.7",
												color: "#333",
												textAlign: "justify",
											}}>
											The Human Resource Management department also reports to
											the Medical Director. This department is crucial for
											managing staff recruitment, training, and overall human
											resource policies. By ensuring a well-functioning and
											motivated workforce, the Human Resource Management
											department supports the hospital's mission and goals.
										</p>
									</div>
								</div>
							</div>

							<div className="row mb-4">
								<div className="col-12">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#f8f9fa",
											padding: "1.5rem",
											borderRadius: "8px",
											borderLeft: '4px solid var(--tgh-blue-light)',
											marginBottom: "1.5rem",
										}}>
										<h4
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.2rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Hospital Administrator (Head of HASS)
										</h4>
										<p
											style={{
												fontSize: "0.95rem",
												lineHeight: "1.7",
												color: "#333",
												marginBottom: "0.75rem",
												textAlign: "justify",
											}}>
											The Hospital Administrator, also referred to as the Head
											of Hospital Administration and Support Services (HASS),
											oversees several operational departments:
										</p>
										<ul
											style={{
												fontSize: "0.95rem",
												lineHeight: "1.7",
												color: "#333",
												paddingLeft: "1.5rem",
											}}>
											<li>
												<strong>Estates:</strong> Manages hospital properties
												and facilities
											</li>
											<li>
												<strong>Transport:</strong> Handles the logistics and
												transportation needs
											</li>
											<li>
												<strong>Procurement & Stores:</strong> Responsible for
												acquiring and storing supplies
											</li>
											<li>
												<strong>Laundry & CSSD:</strong> Takes care of laundry
												services and the Central Sterile Services Department
											</li>
											<li>
												<strong>Catering:</strong> Provides food services for
												patients and staff
											</li>
											<li>
												<strong>Social Welfare:</strong> Addresses the social
												needs of patients
											</li>
											<li>
												<strong>Mortuary:</strong> Manages mortuary services
											</li>
											<li>
												<strong>Environment:</strong> Ensures a clean and safe
												hospital environment
											</li>
											<li>
												<strong>Security:</strong> Ensures the safety and protection of patients, staff, visitors, and hospital property
											</li>
											<li>
												<strong>HIO / Records:</strong> Manages patient information and medical records, ensuring they are accurate, secure, confidential, and easily retrievable
											</li>
											<li>
												<strong>Information Technology:</strong> Manages the hospital’s computers, networks, systems, and digital services to support efficient healthcare operations.
											</li>
											<li>
												<strong>Telephone Exchange:</strong>Manages the hospital’s telephone communication system, ensuring calls are properly received, connected, and directed.
											</li>
											<li>
												<strong>Training Unit</strong> Coordinates staff training and development to improve knowledge, skills, performance, and quality of service
											</li>
										</ul>
									</div>
								</div>
							</div>

							<div className="row mb-4">
								<div className="col-12 col-lg-6 mb-4 mb-lg-0">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#f8f9fa",
											padding: "1.5rem",
											borderRadius: "8px",
											height: "100%",
											borderLeft: '4px solid var(--tgh-blue-light)',
										}}>
										<h4
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.2rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Clinical Coordinator
										</h4>
										<p
											style={{
												fontSize: "0.95rem",
												lineHeight: "1.7",
												color: "#333",
												textAlign: "justify",
											}}>
											The Clinical Coordinator also reports to the Medical
											Director and is responsible for the clinical operations of
											the hospital. This role includes overseeing the Clinical
											Heads of Departments, who lead various clinical
											departments. The Clinical Coordinator also manages the
											medical workforce, which includes medical staff, house
											officers (interns), and medical students, ensuring that
											clinical services are delivered efficiently and
											effectively.
										</p>
									</div>
								</div>
								<div className="col-12 col-lg-6">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#f8f9fa",
											padding: "1.5rem",
											borderRadius: "8px",
											height: "100%",
											borderLeft: '4px solid var(--tgh-blue-light)',
										}}>
										<h4
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.2rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Head of Pharmacy
										</h4>
										<p
											style={{
												fontSize: "0.95rem",
												lineHeight: "1.7",
												color: "#333",
												textAlign: "justify",
											}}>
											The Head of Pharmacy reports to the Medical Director and
											oversees the Pharmacy and Dispensary Staff. This team is
											responsible for medication management and pharmaceutical
											services, ensuring that patients receive the correct
											medications in a timely manner and that all pharmaceutical
											operations comply with regulatory standards.
										</p>
									</div>
								</div>
							</div>

							<div className="row mb-4">
								<div className="col-12 col-lg-6 mb-4 mb-lg-0">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#f8f9fa",
											padding: "1.5rem",
											borderRadius: "8px",
											height: "100%",
											borderLeft: '4px solid var(--tgh-blue-light)',
										}}>
										<h4
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.2rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Head of Nursing
										</h4>
										<p
											style={{
												fontSize: "0.95rem",
												lineHeight: "1.7",
												color: "#333",
												textAlign: "justify",
											}}>
											The Head of Nursing also reports to the Medical Director
											and manages the nursing department. This includes Ward
											In-Charges, who lead different nursing wards, and the
											nursing workforce, which comprises nursing staff,
											midwives, auxiliary staff, and nursing students. The Head
											of Nursing ensures that all nursing services are delivered
											with the highest standards of care and professionalism.
										</p>
									</div>
								</div>
								<div className="col-12 col-lg-6">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#f8f9fa",
											padding: "1.5rem",
											borderRadius: "8px",
											height: "100%",
											borderLeft: '4px solid var(--tgh-blue-light)',
										}}>
										<h4
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.2rem",
												fontWeight: "bold",
												marginBottom: "0.75rem",
											}}>
											Head of Finance
										</h4>
										<p
											style={{
												fontSize: "0.95rem",
												lineHeight: "1.7",
												color: "#333",
												textAlign: "justify",
											}}>
											The Head of Finance reports to the Medical Director and
											supervises the finance staff. This department is
											responsible for the hospital's financial operations,
											including budgeting, accounting, and financial planning.
											By managing the hospital's finances effectively, the Head
											of Finance ensures that the hospital remains financially
											stable and capable of providing high-quality healthcare
											services.
										</p>
									</div>
								</div>
							</div>
						</ScrollSection>

						{/* Operational Information */}
						<ScrollSection>
							<div
								className="row mb-5 governance-section-spacing"
								style={{ marginTop: "60px" }}>
								<div className="col-12">
									<div
										className="governance-card"
										style={{
											backgroundColor: "#f8f9fa",
											padding: "2rem",
											borderRadius: "8px",
											borderLeft: "4px solid #dc3545",
										}}>
										<h3
											style={{
												color: 'var(--tgh-blue-light)',
												fontFamily: "Georgia, serif",
												fontSize: "1.5rem",
												fontWeight: "bold",
												marginBottom: "1rem",
											}}>
											Hospital Operations
										</h3>
										<p
											style={{
												fontSize: "1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1rem",
												textAlign: "justify",
											}}>
											Despite challenges including insufficient staffing,
											inadequate accommodation for employees, poor
											infrastructure with structural defects, and a lack of
											security personnel, Tema General Hospital continues to
											evolve to meet the healthcare demands of its patients. It
											currently operates with{" "}
											<strong>twelve wards, a bed capacity of 439</strong>, and
											provides{" "}
											<strong>24-hour specialist and general services</strong>{" "}
											to both outpatients and inpatients.
										</p>
										<p
											style={{
												fontSize: "1rem",
												lineHeight: "1.8",
												color: "#333",
												marginBottom: "1rem",
												textAlign: "justify",
											}}>
											The hospital offers a wide range of services, including
											Internal Medicine, General Surgery, Obstetrics and
											Gynaecology, Paediatrics, Reproductive and Child Health
											Care/Family Planning, and Emergency Services.
											Additionally, it runs specialized clinics such as Eye
											Care, Dental, Diabetic Clinic, Intensive Care,
											Dermatology, ENT, Chest, Hypertensive, and Anesthetic
											Clinics, as well as the ART/PMTCT Unit.
										</p>
										<p
											style={{
												fontSize: "1rem",
												lineHeight: "1.8",
												color: "#333",
												textAlign: "justify",
											}}>
											Support services such as Laboratory/Blood Bank,
											Radiology/Ultrasound, Pharmacy, Physiotherapy, and ECG,
											along with facilities including a Staff Rest Room,
											Catering, Mortuary, Laundry/CSSD, Stores and Supplies,
											Estate, Social Welfare, Mental Health Unit, and Wellness
											Centre, ensure comprehensive care delivery.
										</p>
									</div>
								</div>
							</div>
						</ScrollSection>

						{/* Organizational Chart Image Section */}
						<ScrollSection>
							<div
								className="position-relative mb-5"
								style={{ marginTop: "60px" }}>
								<h2
									className="mb-0"
									style={{
										fontWeight: "bold",
										color: "rgba(var(--tgh-blue-rgb), 0.1)",
										position: "absolute",
										top: "-20px",
										left: "0",
										zIndex: 0,
										fontSize: "4rem",
										fontFamily: "Georgia, serif",
									}}>
									Structure
								</h2>
								<h2
									className="position-relative"
									style={{
										fontWeight: "bold",
										color: 'var(--tgh-blue-light)',
										borderBottom: "3px solid #dc3545",
										paddingBottom: "10px",
										display: "inline-block",
										zIndex: 1,
										fontFamily: "Georgia, serif",
										fontSize: "2.5rem",
									}}>
									Tema General Hospital Organizational Structure
								</h2>
							</div>

							<div className="row mb-5">
								<div className="col-12">
									<div
										className="governance-image-container"
										style={{
											textAlign: "center",
											padding: "2rem",
											backgroundColor: "#f8f9fa",
											borderRadius: "8px",
											boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
										}}>
										<img
											src="/img/OrgStructuree.png"
											alt="Tema General Hospital Organizational Structure"
											style={{
												maxWidth: "100%",
												height: "auto",
												display: "block",
												margin: "0 auto",
												borderRadius: "4px",
											}}
											onError={(e) => {
												// Try alternative image names if the first one fails
												if (e.target.src.includes("OrgStructure.png")) {
													e.target.src = "/img/organizationStructure.png";
												} else if (
													e.target.src.includes("organizationStructure.png")
												) {
													e.target.src = "/img/ORGCH.png";
												}
											}}
										/>
									</div>
								</div>
							</div>
						</ScrollSection>
					</div>
				);
			case "senior-management":
				return <SeniorManagementTabContent />;
			default:
				return null;
		}
	};

	return (
		<>
			<div
				className="container-fluid page-header wow fadeIn"
				data-wow-delay="0.1s"
				style={{
					backgroundColor: 'var(--tgh-blue)',
					backgroundSize: "cover",
					backgroundPosition: "center",
				}}>
				<div className="container text-center py-5 mt-4">
					<h1 className="display-2 text-white fw-bold mb-3 animated slideInDown">
						About Us
					</h1>
					<nav aria-label="breadcrumb animated slideInDown">
						<ol className="breadcrumb justify-content-center mb-0">
							<li className="breadcrumb-item fw-bold">
								<Link to="/" className="text-white">
									Home
								</Link>
							</li>
							<li
								className="breadcrumb-item fw-bold text-white"
								aria-current="page">
								About Us
							</li>
						</ol>
					</nav>
				</div>
			</div>

			<div className="container py-5 about-us-container">
				{/* Tabs Navigation */}
				<div
					className="about-us-tabs-wrapper"
					style={{ overflowX: "auto", WebkitOverflowScrolling: "touch" }}>
					<ul
						className="nav nav-tabs mb-4 about-us-tabs"
						role="tablist"
						style={{
							borderBottom: "2px solid #dee2e6",
							flexWrap: "nowrap",
							minWidth: "max-content",
						}}>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === "overview" ? "active" : ""}`}
								onClick={() => handleTabChange("overview")}
								type="button"
								style={{
									cursor: "pointer",
									color: activeTab === "overview" ? "var(--tgh-blue)" : "#666",
									fontWeight: activeTab === "overview" ? "600" : "400",
									border: "none",
									borderBottom:
										activeTab === "overview"
											? "3px solid var(--tgh-blue)"
											: "3px solid transparent",
									backgroundColor: "transparent",
									padding: "10px 20px",
									whiteSpace: "nowrap",
								}}>
								Overview of TGH
							</button>
						</li>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === "history" ? "active" : ""}`}
								onClick={() => handleTabChange("history")}
								type="button"
								style={{
									cursor: "pointer",
									color: activeTab === "history" ? "var(--tgh-blue)" : "#666",
									fontWeight: activeTab === "history" ? "600" : "400",
									border: "none",
									borderBottom:
										activeTab === "history"
											? "3px solid var(--tgh-blue)"
											: "3px solid transparent",
									backgroundColor: "transparent",
									padding: "10px 20px",
									whiteSpace: "nowrap",
								}}>
								History & Background
							</button>
						</li>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === "governance" ? "active" : ""}`}
								onClick={() => handleTabChange("governance")}
								type="button"
								style={{
									cursor: "pointer",
									color: activeTab === "governance" ? "var(--tgh-blue)" : "#666",
									fontWeight: activeTab === "governance" ? "600" : "400",
									border: "none",
									borderBottom:
										activeTab === "governance"
											? "3px solid var(--tgh-blue)"
											: "3px solid transparent",
									backgroundColor: "transparent",
									padding: "10px 20px",
									whiteSpace: "nowrap",
								}}>
								Governance Structure
							</button>
						</li>
						<li className="nav-item">
							<button
								className={`nav-link ${activeTab === "senior-management" ? "active" : ""}`}
								onClick={() => handleTabChange("senior-management")}
								type="button"
								style={{
									cursor: "pointer",
									color: activeTab === "senior-management" ? "var(--tgh-blue)" : "#666",
									fontWeight: activeTab === "senior-management" ? "600" : "400",
									border: "none",
									borderBottom:
										activeTab === "senior-management"
											? "3px solid var(--tgh-blue)"
											: "3px solid transparent",
									backgroundColor: "transparent",
									padding: "10px 20px",
									whiteSpace: "nowrap",
								}}>
								Senior Management
							</button>
						</li>
					</ul>
				</div>

				{/* Tab Content */}
				<div className="tab-content mt-4">{renderTabContent()}</div>
			</div>

			{/* TGH Within The Structure of Ghana Health Service - Outside container for full width */}
			{activeTab === "overview" && (
				<div className="row mb-0 mx-0">
					<div className="col-12 px-0">
						<div
							className="position-relative about-us-ghs-section py-5"
							style={{
								background:
									"linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url(/img/carousel/admin2.jpg)",
								backgroundSize: "cover",
								backgroundPosition: "center",
                /* overflow:"none",*/
								display: "flex",
								flexDirection: "column",
								justifyContent: "center",
								width: "100%",
								marginBottom: "0",
							}}>
							<div className="container">
								<div className="position-relative mb-4 text-center">
									<h2
										className="text-white mb-0 about-us-ghs-title"
										style={{ fontWeight: "bold", zIndex: 1 }}>
										TGH Within The Structure of Ghana Health Service
									</h2>
								</div>
								<div className="row">
									<div className="col-12">
										<p
											className="mb-3 text-white about-us-ghs-text"
											style={{ lineHeight: "1.8" }}>
											The Ghana Health Service (GHS) operates on a four-tier
											system of care: Community Health Planning Services (CHPS),
											Health Centre/Polyclinic, District Hospital, and Regional
											Hospital. At the community level, CHPS Zones provide
											preventive care, health promotion, and basic outpatient
											services, serving as the first point of contact for many
											patients.
										</p>
										<p
											className="mb-3 text-white about-us-ghs-text"
											style={{ lineHeight: "1.8" }}>
											Health Centres at the Sub-District level offer outpatient
											services and basic diagnostic tests, while District
											Hospitals provide general and specialized services, handle
											referrals from lower levels, and refer complex cases to
											Regional or Teaching Hospitals. These facilities form the
											backbone of primary and secondary healthcare delivery in
											Ghana.
										</p>
										<p
											className="mb-3 text-white about-us-ghs-text"
											style={{ lineHeight: "1.8" }}>
											Tema General Hospital (TGH) is licensed by the Health
											Facilities Regulatory Agency (HeFRA) as a Tertiary
											Hospital, managed by a Medical Director. As a tertiary
											facility, TGH provides specialist care, utilizes complex
											medical equipment, and serves as a referral center for
											cases requiring advanced medical intervention. The
											hospital also refers complex cases to Teaching and other
											Specialist Hospitals when necessary.
										</p>
										<p
											className="mb-0 text-white about-us-ghs-text"
											style={{ lineHeight: "1.8" }}>
											TGH serves as a Regional Referral Facility within the
											Ghana Health Service, offering high-level tertiary health
											services and providing technical support to healthcare
											facilities in the Greater Accra Region. The hospital is
											committed to meeting the highest possible standards of
											efficiency, effectiveness, and quality in all its
											endeavors, driven by excellence, continuous improvement,
											and innovation.
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			)}
		</>
	);
}

// Senior Management Tab Content Component
function SeniorManagementTabContent() {
	const [management, setManagement] = useState([]);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		fetchManagement();
	}, []);

	const fetchManagement = async () => {
		try {
			const response = await axios.get("/api/senior-management");
			setManagement(response.data.management || []);
		} catch (error) {
			console.error("Error fetching management:", error);
		} finally {
			setLoading(false);
		}
	};

	return (
		<div style={{ maxWidth: "1200px", margin: "0 auto" }}>
			<ScrollSection>
				<div className="mb-5">
					<h2
						style={{
							fontFamily: "Georgia, serif",
							fontWeight: "bold",
							color: 'var(--tgh-blue-light)',
							fontSize: "2rem",
							marginBottom: "1rem",
						}}>
						Senior Management Team
					</h2>
					<p
						style={{
							fontSize: "1.1rem",
							lineHeight: "1.8",
							color: "#333",
							marginBottom: "2rem",
						}}>
						Our senior management team consists of experienced healthcare
						professionals and administrators who bring years of expertise and
						dedication to their roles. They work collaboratively to ensure the
						hospital operates efficiently and delivers the highest quality of
						care to our patients.
					</p>
				</div>
			</ScrollSection>

			{loading ? (
				<ScrollSection>
					<div className="text-center py-5">
						<div
							className="spinner-border text-primary"
							role="status"
							style={{ width: "3rem", height: "3rem" }}>
							<span className="visually-hidden">Loading...</span>
						</div>
					</div>
				</ScrollSection>
			) : management.length > 0 ? (
				<ScrollSection>
					<div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4 tgh-senior-management-grid">
						{management.map((member) => (
							<div className="col" key={member.id}>
								<div
									className="card h-100 border-0"
									style={{
										boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
										transition: "transform 0.3s ease, box-shadow 0.3s ease",
										borderRadius: "8px",
										overflow: "hidden",
									}}
									onMouseEnter={(e) => {
										e.currentTarget.style.transform = "translateY(-5px)";
										e.currentTarget.style.boxShadow =
											"0 4px 12px rgba(0,0,0,0.15)";
									}}
									onMouseLeave={(e) => {
										e.currentTarget.style.transform = "translateY(0)";
										e.currentTarget.style.boxShadow =
											"0 2px 8px rgba(0,0,0,0.1)";
									}}>
									<Link
										to={`/senior-management/${member.id}`}
										className="text-decoration-none">
										<div
											className="tgh-senior-grid-image-frame"
											style={{
												width: "100%",
												paddingTop: "100%",
												position: "relative",
												overflow: "hidden",
												backgroundColor: "#f8f9fa",
											}}>
											<img
												src={
													member.image ||
													"/img/Male Professional Headshot - East African.jpeg"
												}
												alt={member.name}
												className="tgh-senior-grid-image"
												style={{
													position: "absolute",
													top: 0,
													left: 0,
													width: "100%",
													height: "100%",
													objectFit: "cover",
													objectPosition: "top center",
												}}
												onError={(e) => {
													e.target.src =
														"/img/Male Professional Headshot - East African.jpeg";
												}}
											/>
										</div>
									</Link>
									<div className="card-body" style={{ padding: "1.25rem" }}>
										<h5
											style={{
												marginBottom: "0.5rem",
												fontFamily: "Georgia, serif",
												fontSize: "1.1rem",
												fontWeight: "600",
											}}>
											<Link
												to={`/senior-management/${member.id}`}
												className="text-decoration-none"
												style={{ color: 'var(--tgh-blue-light)' }}
												onMouseEnter={(e) => {
													e.currentTarget.style.textDecoration = "underline";
												}}
												onMouseLeave={(e) => {
													e.currentTarget.style.textDecoration = "none";
												}}>
												{member.name}
											</Link>
										</h5>
										<p
											style={{
												marginBottom: 0,
												fontSize: "0.95rem",
												color: "#666",
												lineHeight: "1.5",
											}}>
											{member.designation}
										</p>
									</div>
								</div>
							</div>
						))}
					</div>
				</ScrollSection>
			) : (
				<ScrollSection>
					<div className="text-center py-5">
						<p style={{ fontSize: "1.1rem", color: "#666" }}>
							No management team members available at this time.
						</p>
					</div>
				</ScrollSection>
			)}
		</div>
	);
}

export default AboutUs;
